import { CellItem } from '@components/UI-Components/HierarchyWiseItemsTable/components/Row/Cell'
import InputEditor from '@components/UI-Components/InputEditor'
import useOrderContext from '@modules/order/hooks/use-order-context'
import useViewContext from '@modules/order/hooks/use-view-context'
import { PRODUCT_OPERATIONS_LOADERS } from '@modules/order/stores/view/List/ListDataStore'
import { hasUserRoles } from '@services/userRoleService'
import get from 'lodash/get'
import isNumber from 'lodash/isNumber'
import { useObserver } from 'mobx-react-lite'
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import EnhancedCell from './EnhancedCell'
import { EnhancedListUIStore } from '@modules/showroom/EnhancedOrder/stores/EnhancedListView/EnhancedListUIStore'
import { useEnhancedProductStatus } from '@components/UI-Components/ProductCard/ProductStatusHook'

const EnhancedComments: ({ commentType, allowedUserRoles }) => FC<CellItem> =
  ({ commentType, allowedUserRoles }) =>
  ({ rowData, column }) =>
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useObserver(function useHook() {
      const {
        uiStore: { isOrderEditable }
      } = useOrderContext()
      const { t } = useTranslation()
      const viewContextValue = useViewContext()
      const isProductActive: boolean = useEnhancedProductStatus(rowData)

      if (!rowData) {
        return <></>
      }
      const { updateComment, dataStore } =
        viewContextValue.uiStore as EnhancedListUIStore<any>
      const value = get(rowData, column.enhancedField)

      const index = rowData?.id
        ? dataStore.itemIndexObjectStore.getIndexByKey(rowData.id)
        : null
      const disabled = isNumber(index)
        ? dataStore.itemIndexObjectStore.isObjectsDataLoading(
            index,
            index + 1,
            `${PRODUCT_OPERATIONS_LOADERS.UPDATING_DRAFT_QUANTITY}_${commentType}`
          ) || !hasUserRoles(allowedUserRoles)
        : false
      return (
        <EnhancedCell>
          <InputEditor
            disabled={disabled || !isProductActive || !isOrderEditable}
            header={t('order.rmComment.placeholder', 'Edit Comment')}
            onChange={value => updateComment(rowData.id, value, commentType)}
            placeholder={!disabled && t('order.rmComment.placeholder', 'Edit Comment')}
            value={value}
            className={'CM' === commentType ? { typography: 'clearText' } : {}}
            isEnhancedViewEnabled={true}
          />
        </EnhancedCell>
      )
    })

export default EnhancedComments
